/**
 * Map geometry shared by the portal's maps — the admin attendance map and the
 * employee check-in confirmation (FEAT-2026-025).
 */

export type Point = { lat: number; lng: number };

/**
 * Metres to degrees, for widening the fitted bounds so a geofence circle is
 * never clipped at the viewport edge. Accurate to well under a metre at
 * Malaysian latitudes, which is all a camera fit needs.
 */
export function padForRadius(p: Point, radiusM: number): Point[] {
  const dLat = radiusM / 111_320;
  const dLng = radiusM / (111_320 * Math.cos((p.lat * Math.PI) / 180));
  return [
    { lat: p.lat + dLat, lng: p.lng + dLng },
    { lat: p.lat - dLat, lng: p.lng - dLng },
  ];
}
